import { useQuery } from '@tanstack/react-query';

import { FreelancerSubunitResource } from '@/types/resources';
import { api } from '@/utils/api';

const useFreelancerSubunitsOptions = () => {
  return useQuery(
    ['freelancer_subunits'],
    () =>
      api.get<never, FreelancerSubunitResource[]>('/v1/freelancer-subunits'),
    {
      select: (data) =>
        data.map((item) => ({
          value: item.id,
          label: item.name,
          hide_from_dropdowns: item.hide_from_dropdowns,
        })),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
  );
};

export default useFreelancerSubunitsOptions;
